export const initializeState = ({ list }) => {
  try {
    return list;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`initializeState: ${e}`);
  }
  return undefined;
};
